export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

type TranslateFunction = (key: string) => string;

export const validatePassword = (password: string, t: TranslateFunction): string[] => {
  const errors: string[] = [];

  if (password.length < 10) {
    errors.push(t("passwordValidation.minLength"));
  }

  if (!/[a-z]/.test(password)) {
    errors.push(t("passwordValidation.lowercase"));
  }

  if (!/[A-Z]/.test(password)) {
    errors.push(t("passwordValidation.uppercase"));
  }

  if (!/[0-9]/.test(password)) {
    errors.push(t("passwordValidation.number"));
  }

  // eslint-disable-next-line no-useless-escape
  if (!/[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\\/;'`~]/.test(password)) {
    errors.push(t("passwordValidation.specialChar"));
  }

  return errors;
};

export const getPasswordRequirements = (t: TranslateFunction): string => {
  return t("passwordValidation.requirements");
};
